import { render } from "./Form.vue?vue&type=template&id=c51bad96&scoped=true&lang=pug&bindings={\"id\":\"props\",\"inputs\":\"props\"}"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=c51bad96&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-c51bad96"

export default script